import * as React from 'react';

const CartIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3676 17.25H6.6631L4.0478 2.86584C4.01638 2.69303 3.9253 2.53673 3.79046 2.42419C3.65561 2.31164 3.48554 2.25 3.30989 2.25H1.61765"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.61765 21C8.65318 21 9.49265 20.1605 9.49265 19.125C9.49265 18.0895 8.65318 17.25 7.61765 17.25C6.58211 17.25 5.74265 18.0895 5.74265 19.125C5.74265 20.1605 6.58211 21 7.61765 21Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3676 21C18.4032 21 19.2426 20.1605 19.2426 19.125C19.2426 18.0895 18.4032 17.25 17.3676 17.25C16.3321 17.25 15.4926 18.0895 15.4926 19.125C15.4926 20.1605 16.3321 21 17.3676 21Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.98128 13.5H17.7521C18.1034 13.5 18.4436 13.3767 18.7133 13.1516C18.983 12.9265 19.1651 12.6139 19.2279 12.2683L20.3676 6H4.61765"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CartIcon;
